import React from 'react';
import FilterPill from '../FilterPill/FilterPill';
import './InlineFoilPills.css';

interface InlineFoilPillsProps {
  acceptFoil: boolean;
  acceptNonFoil: boolean;
  onChange: (acceptFoil: boolean, acceptNonFoil: boolean) => void;
  disabled?: boolean;
}

const InlineFoilPills: React.FC<InlineFoilPillsProps> = ({
  acceptFoil,
  acceptNonFoil,
  onChange,
  disabled = false,
}) => {
  const handleFoilToggle = () => {
    if (disabled) return;
    
    // If turning off foil and non-foil is already off, don't allow
    if (acceptFoil && !acceptNonFoil) {
      return;
    }
    
    onChange(!acceptFoil, acceptNonFoil);
  };

  const handleNonFoilToggle = () => {
    if (disabled) return;
    
    // If turning off non-foil and foil is already off, don't allow
    if (acceptNonFoil && !acceptFoil) {
      return;
    }
    
    onChange(acceptFoil, !acceptNonFoil);
  };

  return (
    <div className={`inline-foil-pills ${disabled ? 'disabled' : ''}`}>
      <FilterPill
        label="Foil"
        active={acceptFoil}
        onToggle={handleFoilToggle}
      />
      <FilterPill
        label="Non-foil"
        active={acceptNonFoil}
        onToggle={handleNonFoilToggle}
      />
    </div>
  );
};

export default InlineFoilPills;